<script lang="ts">
	// DS
	import { DropdownMenu, MenuItemList, IconButton } from '@Shelly/shelly-design-system/index';
	// Components
	import OptionManagmentModal from 'src/components/OptionManagmentModal.svelte';
	// Stores
	import { is_mobile, is_tablet } from 'src/stores/ui/viewport';
	// Types
	import type { MenuItemListExtendedProps } from '../dash-types';
	import { mapIconSolidWeightToLight } from 'src/helpers/new-layout-helpers';

	export let menuListItemsData: MenuItemListExtendedProps[];

	let showDropdown = false;
	let showModal = false;

	const toggleDashActions = () => {
		if ($is_tablet || $is_mobile) {
			showModal = !showModal;
		} else if (!$is_tablet && !$is_mobile) {
			showDropdown = !showDropdown;
		}
	};

	function prepareModalData() {
		return {
			topSectionTitle: menuListItemsData[0]?.title || 'Manage Dashboard',
			itemsTop:
				menuListItemsData[0]?.items?.map((item) => ({
					...item,
					title: item.title,
					titleDefault: item.title,
					icon: mapIconSolidWeightToLight(item.iconMobile || item.icon),
					disabled: item.disabled || false,
					onClick: item.onClick,
				})) || [],

			bottomSectionTitle: menuListItemsData[1]?.title || 'Manage Widgets',
			itemsBottom:
				menuListItemsData[1]?.items?.map((item) => ({
					...item,
					title: item.title,
					titleDefault: item.title,
					icon: mapIconSolidWeightToLight(item.iconMobile || item.icon),
					disabled: item.disabled || false,
					onClick: item.onClick,
				})) || [],
		};
	}

	let modalConfig = prepareModalData();

	$: (menuListItemsData, (modalConfig = prepareModalData()));
</script>

<DropdownMenu bind:show={showDropdown}>
	<IconButton
		slot="trigger"
		aria-label="Dash toolbar more btn"
		variant="secondary"
		icon="fas fa-ellipsis-vertical"
		on:click={() => {
			toggleDashActions();
		}}
	/>

	{#each menuListItemsData as groupItem}
		<MenuItemList isGroupTitle={groupItem.isGroupTitle} size="m" title={groupItem.title} />

		{#each groupItem.items as menuListItem}
			<MenuItemList
				isGroupItem
				size="m"
				title={menuListItem.title}
				titleClasses={menuListItem.titleClasses}
				icon={menuListItem.icon}
				iconStyle={menuListItem?.iconStyle}
				disabled={menuListItem.disabled}
				on:click={() => {
					toggleDashActions();
					menuListItem.onClick(menuListItem);
				}}
			/>
		{/each}
	{/each}
</DropdownMenu>

<OptionManagmentModal
	bind:showModal
	topSectionTitle={modalConfig.topSectionTitle}
	bottomSectionTitle={modalConfig.bottomSectionTitle}
	itemsTop={modalConfig.itemsTop}
	itemsBottom={modalConfig.itemsBottom}
/>
